import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Mail, Eye, CheckCircle2, ChevronRight, Search, Users } from 'lucide-react';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const CrmInvitations = () => {
  const [list, setList] = useState([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);

  const fetchList = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_URL}/api/admin/invitations`, {
        params: search ? { search } : {},
        withCredentials: true,
      });
      setList(res.data || []);
    } catch { toast.error('Could not load invitations'); }
    finally { setLoading(false); }
  };
  useEffect(() => { fetchList(); /* eslint-disable-next-line */ }, []);

  const onSearch = (e) => { e.preventDefault(); fetchList(); };

  return (
    <div className="space-y-5" data-testid="crm-invitations">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-[#1E1E24]" style={{ fontFamily: 'Fredoka' }}>Birthday Invitations</h1>
        <p className="text-xs text-[#6B6B7A]">{list.length} total</p>
      </div>

      <form onSubmit={onSearch} className="flex gap-2 max-w-md">
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#6B6B7A]" />
          <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Search by child, email, booking_id…" className="pl-9" data-testid="invitations-search" />
        </div>
        <Button type="submit" className="rounded-full bg-[#1E1E24] text-white px-5">Search</Button>
      </form>

      {loading ? (
        <p className="text-[#6B6B7A]">Loading…</p>
      ) : list.length === 0 ? (
        <div className="bg-white rounded-2xl border border-[#E8E5DF] p-10 text-center text-sm text-[#6B6B7A]">No invitations found.</div>
      ) : (
        <div className="bg-white rounded-2xl border border-[#E8E5DF] overflow-hidden">
          <div className="grid grid-cols-12 px-4 py-2 text-xs font-medium text-[#6B6B7A] border-b border-[#E8E5DF]">
            <div className="col-span-3">Child</div>
            <div className="col-span-3">Owner</div>
            <div className="col-span-2">Date</div>
            <div className="col-span-1 text-center">Total</div>
            <div className="col-span-1 text-center">Sent</div>
            <div className="col-span-1 text-center">Yes</div>
            <div className="col-span-1"></div>
          </div>
          <div className="divide-y divide-[#E8E5DF]" data-testid="invitations-list">
            {list.map((inv) => (
              <div key={inv.invitation_id} className="grid grid-cols-12 px-4 py-3 items-center text-sm hover:bg-[#FFFDF8]" data-testid={`invitation-row-${inv.invitation_id}`}>
                <div className="col-span-3">
                  <p className="font-medium text-[#1E1E24] truncate">{inv.child_name} <span className="text-[#6B6B7A] text-xs">({inv.age})</span></p>
                  <p className="text-xs text-[#6B6B7A]">{inv.party_time} · {inv.location}</p>
                </div>
                <div className="col-span-3 truncate">
                  <p className="text-[#1E1E24] truncate">{inv.owner_name || '—'}</p>
                  <p className="text-xs text-[#6B6B7A] truncate">{inv.owner_email}</p>
                </div>
                <div className="col-span-2 text-[#1E1E24] text-xs">{inv.party_date}</div>
                <div className="col-span-1 text-center text-[#1E1E24] font-semibold"><Users className="w-3 h-3 inline mr-0.5 text-[#6B6B7A]" />{inv.recipients_count || 0}</div>
                <div className="col-span-1 text-center text-[#FF7A2E]"><Mail className="w-3 h-3 inline mr-0.5" />{inv.sent_count || 0}</div>
                <div className="col-span-1 text-center text-[#06D6A0] font-semibold"><CheckCircle2 className="w-3 h-3 inline mr-0.5" />{inv.yes_count || 0}</div>
                <div className="col-span-1 text-right">
                  <Link to={`/crm/invitations/${inv.invitation_id}`} className="inline-block p-1.5 rounded-full hover:bg-[#FFE4EB]" data-testid={`open-invitation-${inv.invitation_id}`}>
                    <ChevronRight className="w-4 h-4 text-[#FF3B6B]" />
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default CrmInvitations;
